import React from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";


import { UserContext } from "../../UserContext";

const Home = () => {

    var settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };
   
  const imageStyle2 = {
    top: '120px',
    left: '530px',
    whiteSpace: 'nowrap',
  };
  const imageStyle3 = {
    top: '420px',
    left: '-375px',
    zIndex: 100,
    whiteSpace: 'nowrap',
  };
  const imageStyle4 = {
    top: '185px',
    left: '530px',
    whiteSpace: 'nowrap',
  };
  const imageStyle5 = {
    top: '252px',
    left: '507px',
    whiteSpace: 'nowrap',
  };
  const imageStyle6 = {
    top: '250px',
    left: '571px',
    whiteSpace: 'nowrap',
  };
  const imageStyle7 = {
    top: '355px',
    left: '518px',
    whiteSpace: 'nowrap',
  };
  const imageStyle8 = {
    top: '405px',
    left: '509px',
    whiteSpace: 'nowrap',
  };
  const imageStyle9 = {
    top: '220px',
    left: '370px',
    whiteSpace: 'nowrap',
  };
  const imageStyle10 = {
    top: '42px',
    left: '173px',
    whiteSpace: 'nowrap',
  };
  const imageStyle11 = {
    top: '70px',
    left: '-59px',
    whiteSpace: 'nowrap',
  };
  const imageStyle12 = {
    top: '55px',
    left: '740px',
    whiteSpace: 'nowrap',
  };
  const imageStyle12a = {
    top: '85px',
    left: '955px',
    whiteSpace: 'nowrap',
  };
  const imageStyle13 = {
    top: '35px',
    left: '678px',
    whiteSpace: 'nowrap',
  };
  const imageStyle14 = {
    top: '23px',
    left: '998px',
    whiteSpace: 'nowrap',
  };
  const imageStyle15 = {
    top: '67px',
    left: '679px',
    whiteSpace: 'nowrap',
  };
  const imageStyle16 = {
    top: '78px',
    left: '50px',
    whiteSpace: 'nowrap',
  };
  const imageStyle17 = {
    top: '137px',
    left: '98px',
    whiteSpace: 'nowrap',
  };
  const imageStyle18 = {
    top: '222px',
    left: '96px',
    whiteSpace: 'nowrap',
  };
  const imageStyle19 = {
    top: '397px',
    left: '105px',
    whiteSpace: 'nowrap',
  };
  const imageStyle20 = {
    top: '395px',
    left: '297px',
    whiteSpace: 'nowrap',
  };
  const imageStyle21 = {
    top: '421px',
    left: '100px',
    whiteSpace: 'nowrap',
  };
  const imageStyle22 = {
    top: '30px',
    left: '2px',
    whiteSpace: 'nowrap',
  };
  const imageStyle23 = {
    top: '498px',
    left: '13px',
    whiteSpace: 'nowrap',
  };
  const imageStyle24 = {
    top: '524px',
    left: '507px',
    whiteSpace: 'nowrap',
  };
  const imageStyle25 = {
    top: '25px',
    left: '763px',
    whiteSpace: 'nowrap',
  };
  const imageStyle26 = {
    top: '247px',
    left: '731px',
    whiteSpace: 'nowrap',
  };
  const imageStyle27 = {
    top: '259px',
    left: '888px',
    whiteSpace: 'nowrap',
  };
  const imageStyle28 = {
    top: '402px',
    left: '758px',
    whiteSpace: 'nowrap',
  };
  const imageStyle29 = {
    top: '411px',
    left: '935px',
    whiteSpace: 'nowrap',
  };
  const imageStyle30 = {
    top: '15px',
    left: '1095px',
    transform: 'rotate(100deg)',
    msTransform: 'rotate(100deg)',
    webkitTransform: 'rotate(100deg)',
    whiteSpace: 'nowrap',
  };
  const imageStyle31 = {
    top: '133px',
    left: '686px',
    transform: 'rotate(50deg)',
    msTransform: 'rotate(50deg)',
    webkitTransform: 'rotate(50deg)',
    whiteSpace: 'nowrap',
  };
  const imageStyle32 = {
    top: '516px',
    left: '705px',
    transform: 'rotate(-50deg)',
    msTransform: 'rotate(-50deg)',
    webkitTransform: 'rotate(-50deg)',
    whiteSpace: 'nowrap',
  };
  const imageStyle33 = {
    top: '229px',
    left: '1069px',
    transform: 'rotate(-90deg)',
    msTransform: 'rotate(-90deg)',
    webkitTransform: 'rotate(-90deg)',
    whiteSpace: 'nowrap',
  };
  const imageStyle34 = {
    top: '123px',
    left: '1123px',
    whiteSpace: 'nowrap',
  };
  const imageStyle35 = {
    top: '0px',
    left: '0px',
    whiteSpace: 'nowrap',
  };
  const imageStyle36 = {
    top: '92px',
    left: '-52px',
    whiteSpace: 'nowrap',
  };
  const imageStyle37 = {
    top: '197px',
    left: '-9px',
    whiteSpace: 'nowrap',
  };
  const imageStyle38 = {
    top: '275px',
    left: '-122px',
    whiteSpace: 'nowrap',
  };
  const imageStyle39 = {
    top: '394px',
    left: '-30px',
    whiteSpace: 'nowrap',
  };
  const imageStyle40 = {
    top: '35px',
    left: '555px',
    whiteSpace: 'nowrap',
  };
  const imageStyle41 = {
    top: '395px',
    left: '758px',
    whiteSpace: 'nowrap',
  };
  const imageStyle42 = {
    top: '366px',
    left: '1067px',
    whiteSpace: 'nowrap',
  };
  const imageStyle43 = {
    top: '444px',
    left: '1100px',
    whiteSpace: 'nowrap',
  };
  const imageStyle44 = {
    top: '561px',
    left: '955px',
    whiteSpace: 'nowrap',
  };

  const imagefirst = {
    width: '100%',
    height: '610',
    maxWidth: '1920px',
    margin: '0',
  };

 

  return (
    <main>
      <div id="main">

      <div className="slider-container">
            <Slider {...settings}>
                <div>
                    <picture>
                        <source media="(max-width:750px)" srcset="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Fbanner%2Fbanner01-mobile.webp?alt=media&token=9d9203c5-1338-469a-929f-3bdf8b97f199" />
                        <source media="(max-width:465px)" srcset="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Fbanner%2Fbanner01-mobile.webp?alt=media&token=9d9203c5-1338-469a-929f-3bdf8b97f199" />
                        <img src="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Fbanner%2Fbanner01-desktop.webp?alt=media&token=914665b1-c959-473c-a18f-cc3badab9c6c" />
                    </picture>
                </div>
                <div>
                    <picture>
                        <source media="(max-width:750px)" srcset="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Fbanner%2Fbanner02-mobile.webp?alt=media&token=09cf8712-259e-4c12-94f8-007cffd15ba0" />
                        <source media="(max-width:465px)" srcset="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Fbanner%2Fbanner02-mobile.webp?alt=media&token=09cf8712-259e-4c12-94f8-007cffd15ba0" />
                        <img src="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Fbanner%2Fbanner02-desktop.webp?alt=media&token=b935f78b-a432-4a99-84b3-f259931c5d09" />
                    </picture>
                </div>

            </Slider>
        </div>
       
   

        <section id="primary" class="content-full-width">

          <div class="container">
              <div class="dt-sc-one-third column first">
                  <div class="dt-sc-ico-content type1">
                      <div class="icon">
                          <span class="icon-outer">
                              <img src="https://firebasestorage.googleapis.com/v0/b/psicologia-6d3e3.appspot.com/o/site%2Fimagens%2Ficones%2Ficone-psicologia-infantil.png?alt=media&token=8df58008-e2db-446a-90b7-caeeec1450c8" />
                              <span class="infolayer">
                                  <a href="#"><i class="fa fa-link"></i></a>
                              </span>
                          </span>
                      </div>
                      <h4><a href>Psicoterapia</a></h4>
                      <p class="teste">Médica Pediatra é a responsável por cuidar da saúde das crianças e dos adolescentes. Além de orientar as famílias sobre alimentação, vacinação, aleitamento, desenvolvimento infantil, etc.</p>
                  </div>
              </div>
              <div class="dt-sc-one-third column">
                  <div class="dt-sc-ico-content type1">
                      <div class="icon">
                          <span class="icon-outer">
                              <img src="https://wedesignthemes.com/html/kidslife/images/service2.jpg" />
                              <span class="infolayer">
                                  <a href="#"><i class="fa fa-link"></i></a>
                              </span>
                          </span>
                      </div>
                      <h4><a href>Psicopedagogia</a></h4>
                      <p>é uma area que se dedica a estudar o processo de aprendizagem e a tratar problemas de aprendizagem e comportamento.</p>
                  </div>
              </div>
              <div class="dt-sc-one-third column">
                  <div class="dt-sc-ico-content type1">
                      <div class="icon">
                          <span class="icon-outer">
                              <img src="https://wedesignthemes.com/html/kidslife/images/service3.jpg" />
                              <span class="infolayer">
                                  <a href="#"><i class="fa fa-link"></i></a>
                              </span>
                          </span>
                      </div>
                      <h4><a href>Pediatria</a></h4>
                      <p>Médica Pediatra é a responsável por cuidar da saúde das crianças e dos adolescentes.</p>
                  </div>
              </div>
              <div class="dt-sc-one-third column">
                  <div class="dt-sc-ico-content type1">
                      <div class="icon">
                          <span class="icon-outer">
                              <img src="https://wedesignthemes.com/html/kidslife/images/service4.jpg" />
                              <span class="infolayer">
                                  <a href="#"><i class="fa fa-link"></i></a>
                              </span>
                          </span>
                      </div>
                      <h4><a href>Nutrição</a></h4>
                      <p>O nutricionista infantil é um profissional que ajudará as familias a ajustarem habitos alimentares e a melgorarem as suas praticas.</p>
                  </div>
              </div>
              <div class="dt-sc-one-third column">
                  <div class="dt-sc-ico-content type1">
                      <div class="icon">
                          <span class="icon-outer">
                              <img src="https://wedesignthemes.com/html/kidslife/images/service4.jpg" />
                              <span class="infolayer">
                                  <a href="#"><i class="fa fa-link"></i></a>
                              </span>
                          </span>
                      </div>
                      <h4><a href>Fisioterapia</a></h4>
                      <p>A fisioterapia focada na infância tem por objetivo melhorar o bem estar fisico da criança.</p>
                  </div>
              </div>
              <div class="dt-sc-one-third column">
                  <div class="dt-sc-ico-content type1">
                      <div class="icon">
                          <span class="icon-outer">
                              <img src="https://wedesignthemes.com/html/kidslife/images/service4.jpg" />
                              <span class="infolayer">
                                  <a href="#"><i class="fa fa-link"></i></a>
                              </span>
                          </span>
                      </div>
                      <h4><a href>Avaliação Neuropsicologica</a></h4>
                      <p>é uma avaliação  que analisa o funcionamento cognitivo e comportamental da criança.</p>
                  </div>
              </div>
          </div>

          <div class="dt-sc-hr"></div>

          {/* <section class="fullwidth-background dt-sc-parallax-section turquoise-bg">

              <div class="container">

                  <div class="dt-sc-one-half column first">
                      <h2>Play As You Learn</h2>

                      <div class="dt-sc-one-half column first">
                          <div class="dt-sc-ico-content type2">
                              <div class="icon">
                                  <span class="fa fa-glass"> </span>
                              </div>
                              <h4><a href="#" target="_blank"> English Summer Camp </a></h4>
                              <p>Nam ullamcorper, diam sit amet euismod pelleontesque, eros risus rhoncus libero,
                                  inst tibulum nisl ligula....</p>
                          </div>
                          <div class="dt-sc-hr-very-small"></div>
                          <div class="dt-sc-ico-content type2">
                              <div class="icon">
                                  <span class="fa fa-pencil"> </span>
                              </div>
                              <h4><a href="#" target="_blank"> Drawing & Painting </a></h4>
                              <p>Nam ullamcorper, diam sit amet euismod pelleontesque, eros risus rhoncus libero,
                                  inst tibulum nisl ligula....</p>
                          </div>
                          <div class="dt-sc-hr-very-small"></div>
                          <div class="dt-sc-ico-content type2">
                              <div class="icon">
                                  <span class="fa fa-bullseye"> </span>
                              </div>
                              <h4><a href="#" target="_blank"> Swimming Camp </a></h4>
                              <p>Nam ullamcorper, diam sit amet euismod pelleontesque, eros risus rhoncus libero,
                                  inst tibulum nisl ligula....</p>
                          </div>
                      </div>


                      <div class="dt-sc-one-half column">
                          <div class="dt-sc-ico-content type2">
                              <div class="icon">
                                  <span class="fa fa-tachometer"> </span>
                              </div>
                              <h4><a href="#" target="_blank"> Sports Camp </a></h4>
                              <p>Nam ullamcorper, diam sit amet euismod pelleontesque, eros risus rhoncus libero,
                                  inst tibulum nisl ligula....</p>
                          </div>
                          <div class="dt-sc-hr-very-small"></div>
                          <div class="dt-sc-ico-content type2">
                              <div class="icon">
                                  <span class="fa fa-magic"> </span>
                              </div>
                              <h4><a href="#" target="_blank"> Personalizing </a></h4>
                              <p>Nam ullamcorper, diam sit amet euismod pelleontesque, eros risus rhoncus libero,
                                  inst tibulum nisl ligula....</p>
                          </div>
                          <div class="dt-sc-hr-very-small"></div>
                          <div class="dt-sc-ico-content type2">
                              <div class="icon">
                                  <span class="fa fa-music"> </span>
                              </div>
                              <h4><a href="#" target="_blank"> Sing & Dance </a></h4>
                              <p>Nam ullamcorper, diam sit amet euismod pelleontesque, eros risus rhoncus libero,
                                  inst tibulum nisl ligula....</p>
                          </div>
                      </div>

                  </div>


                  <div class="dt-sc-one-half column">
                      <h2>With Music4Kids, music is child's play!</h2>
                      <div class="add-slider-wrapper">
                        <div className="slider-container">
                            <Slider {...settings}>
                                <div>
                                    <img src="https://wedesignthemes.com/html/kidslife/images/add1.jpg" />
                                </div>
                                <div>
                                    <img src="https://wedesignthemes.com/html/kidslife/images/add2.jpg" />
                                </div>
                                <div>
                                    <img src="https://wedesignthemes.com/html/kidslife/images/add1.jpg" />
                                </div>

                            </Slider>
                        </div>
                          <ul class="add-slider">
                              <li> 
                              </li>
                              <li> 
                              </li>
                              <li> 
                              </li>
                          </ul>
                      </div>
                  </div>

              </div>

          </section> */}

          {/* <div class="dt-sc-hr"></div> */}

          {/* <div class="container">
              <h2 class="dt-sc-hr-green-title">Our Portfolio</h2>

              <div class="front-portfolio-container">
                  <div class="portfolio-content portfolio-content1">
                      <div class="front-portfolio">
                          <div class="portfolio-outer">
                              <div class="portfolio-thumb">
                                  <img src="https://wedesignthemes.com/html/kidslife/images/image1.jpg" />
                                  <div class="image-overlay">
                                      <h5><a href="portfolio-detail.html">Gifts at Large</a></h5>
                                      <a href="portfolio-detail.html" class="link"><span
                                              class="fa fa-link"></span></a>
                                      <a href="https://wedesignthemes.com/html/kidslife/images/image1.jpg"
                                          data-gal="prettyPhoto[gallery]" class="zoom"><span
                                              class="fa fa-search"></span></a>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="portfolio-content portfolio-content2">
                      <div class="front-portfolio">
                          <div class="portfolio-outer">
                              <div class="portfolio-thumb">
                                  <img src="https://wedesignthemes.com/html/kidslife/images/image2.jpg" />
                                  <div class="image-overlay">
                                      <h5><a href="portfolio-detail.html">Gifts at Large</a></h5>
                                      <a href="portfolio-detail.html" class="link"><span
                                              class="fa fa-link"></span></a>
                                      <a href="https://wedesignthemes.com/html/kidslife/images/image2.jpg"
                                          data-gal="prettyPhoto[gallery]" class="zoom"><span
                                              class="fa fa-search"></span></a>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="portfolio-content portfolio-content3">
                      <div class="front-portfolio">
                          <div class="portfolio-outer">
                              <div class="portfolio-thumb">
                                  <img src="https://wedesignthemes.com/html/kidslife/images/image3.jpg" />
                                  <div class="image-overlay">
                                      <h5><a href="portfolio-detail.html">Gifts at Large</a></h5>
                                      <a href="portfolio-detail.html" class="link"><span
                                              class="fa fa-link"></span></a>
                                      <a href="https://wedesignthemes.com/html/kidslife/images/image3.jpg"
                                          data-gal="prettyPhoto[gallery]" class="zoom"><span
                                              class="fa fa-search"></span></a>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="portfolio-content portfolio-content4">
                      <div class="front-portfolio">
                          <div class="portfolio-outer">
                              <div class="portfolio-thumb">
                                  <img src="https://wedesignthemes.com/html/kidslife/images/image4.jpg" />
                                  <div class="image-overlay">
                                      <h5><a href="portfolio-detail.html">Gifts at Large</a></h5>
                                      <a href="portfolio-detail.html" class="link"><span
                                              class="fa fa-link"></span></a>
                                      <a href="https://wedesignthemes.com/html/kidslife/images/image4.jpg"
                                          data-gal="prettyPhoto[gallery]" class="zoom"><span
                                              class="fa fa-search"></span></a>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="portfolio-content portfolio-content5">
                      <div class="front-portfolio">
                          <div class="portfolio-outer">
                              <div class="portfolio-thumb">
                                  <img src="https://wedesignthemes.com/html/kidslife/images/image5.jpg" />
                                  <div class="image-overlay">
                                      <h5><a href="portfolio-detail.html">Gifts at Large</a></h5>
                                      <a href="portfolio-detail.html" class="link"><span
                                              class="fa fa-link"></span></a>
                                      <a href="https://wedesignthemes.com/html/kidslife/images/image5.jpg"
                                          data-gal="prettyPhoto[gallery]" class="zoom"><span
                                              class="fa fa-search"></span></a>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="portfolio-content portfolio-content6">
                      <div class="front-portfolio">
                          <div class="portfolio-outer">
                              <div class="portfolio-thumb">
                                  <img src="https://wedesignthemes.com/html/kidslife/images/image6.jpg" />
                                  <div class="image-overlay">
                                      <h5><a href="portfolio-detail.html">Gifts at Large</a></h5>
                                      <a href="portfolio-detail.html" class="link"><span
                                              class="fa fa-link"></span></a>
                                      <a href="https://wedesignthemes.com/html/kidslife/images/image6.jpg"
                                          data-gal="prettyPhoto[gallery]" class="zoom"><span
                                              class="fa fa-search"></span></a>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="portfolio-content portfolio-content7">
                      <div class="front-portfolio">
                          <div class="portfolio-outer">
                              <div class="portfolio-thumb">
                                  <img src="https://wedesignthemes.com/html/kidslife/images/image7.jpg" />
                                  <div class="image-overlay">
                                      <h5><a href="portfolio-detail.html">Gifts at Large</a></h5>
                                      <a href="portfolio-detail.html" class="link"><span
                                              class="fa fa-link"></span></a>
                                      <a href="https://wedesignthemes.com/html/kidslife/images/image7.jpg"
                                          data-gal="prettyPhoto[gallery]" class="zoom"><span
                                              class="fa fa-search"></span></a>
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <div class="dt-sc-hr-small"></div>
                  <div class="aligncenter">
                      <a href="#" class="dt-sc-button medium mustard"> Hit here to view all <span
                              class="fa fa-chevron-circle-right"> </span></a>
                  </div>
              </div>

          </div> */}

          <div class="dt-sc-hr"></div>

          {/* <section class="fullwidth-background dt-sc-parallax-section orange-bg">

              <div class="container">
                  <h2 class="dt-sc-hr-white-title">Recent Blog</h2>
                  <div class="column dt-sc-one-half first">
                      <article class="blog-entry">
                          <div class="blog-entry-inner">
                              <div class="entry-meta">
                                  <a href="blog-detail.html" class="blog-author"><img
                                          src="https://wedesignthemes.com/html/kidslife/images/rounded-bg-img.jpg"
                                          /></a>
                                  <div class="date">
                                      <span> 27 </span>
                                      <p> Aug <br /> 2014 </p>
                                  </div>
                                  <a href="#" class="comments">
                                      12 <span class="fa fa-comment"> </span>
                                  </a>
                                  <a href="#" class="entry_format"><span class="fa fa-picture-o"></span></a>
                              </div>
                              <div class="entry-thumb">
                                  <a href="blog-detail.html"><img
                                          src="https://wedesignthemes.com/html/kidslife/images/blog_img1.jpg" /></a>
                              </div>
                              <div class="entry-details">
                                  <div class="entry-title">
                                      <h3><a href="blog-detail.html"> Activities Improves Mind </a></h3>
                                  </div>

                                  <div class="entry-body">
                                      <p>Roin bibendum nibhsds. Nuncsdsd fermdada msit ametadasd consequat. Praes
                                          porr nulla sit amet dui lobortis, id venenatis nibh accums.</p>
                                  </div>
                                  <a href="blog-detail.html" class="dt-sc-button small"> Read More <span
                                          class="fa fa-chevron-circle-right"> </span></a>
                              </div>
                          </div>
                      </article>
                  </div>

                  <div class="column dt-sc-one-half">
                      <article class="blog-entry">
                          <div class="blog-entry-inner">
                              <div class="entry-meta">
                                  <a href="blog-detail.html" class="blog-author"><img
                                          src="https://wedesignthemes.com/html/kidslife/images/rounded-bg-img.jpg"
                                          /></a>
                                  <div class="date">
                                      <span> 27 </span>
                                      <p> Aug <br /> 2014 </p>
                                  </div>
                                  <a href="#" class="comments">
                                      12 <span class="fa fa-comment"> </span>
                                  </a>
                                  <a href="#" class="entry_format"><span class="fa fa-picture-o"></span></a>
                              </div>
                              <div class="entry-thumb">
                                  <a href="blog-detail.html"><img
                                          src="https://wedesignthemes.com/html/kidslife/images/blog_img2.jpg" /></a>
                              </div>
                              <div class="entry-details">
                                  <div class="entry-title">
                                      <h3><a href="blog-detail.html"> Weekly Reader Zone </a></h3>
                                  </div>

                                  <div class="entry-body">
                                      <p>Iid venenatis nibh accums. Doinbibe ndum nibhsds. Nuncsdsd fermdada msit
                                          ametadasd consequat. Praes porr nulla sit amet dui lobortis, id
                                          venenatis nibh accumsan...</p>
                                  </div>
                                  <a href="blog-detail.html" class="dt-sc-button small"> Read More <span
                                          class="fa fa-chevron-circle-right"> </span></a>
                              </div>
                          </div>
                      </article>
                  </div>

              </div>

          </section> */}

          <div class="dt-sc-hr"></div>

          {/* <div class="container">
              <h2 class="dt-sc-hr-green-title">Our Staffs</h2>
              <div class="column dt-sc-one-fourth first">
                  <div class="dt-sc-team">
                      <div class="image">
                          <img class="item-mask" src="https://wedesignthemes.com/html/kidslife/images/mask.png"
                              />
                          <img src="https://wedesignthemes.com/html/kidslife/images/team1.jpg" />
                          <div class="dt-sc-image-overlay">
                              <a href="#" class="link"><span class="fa fa-facebook"></span></a>
                              <a href="#" class="zoom"><span class="fa fa-twitter"></span></a>
                          </div>
                      </div>
                      <div class="team-details">
                          <h4> Jack Daniels </h4>
                          <h6> Senior Supervisor </h6>
                          <p> Phasellus lorem augue, vulputate vel orci id, ultricies aliquet risus. </p>
                      </div>
                  </div>
              </div>
              <div class="column dt-sc-one-fourth">
                  <div class="dt-sc-team">
                      <div class="image">
                          <img class="item-mask" src="https://wedesignthemes.com/html/kidslife/images/mask.png"
                              />
                          <img src="https://wedesignthemes.com/html/kidslife/images/team2.jpg" />
                          <div class="dt-sc-image-overlay">
                              <a href="#" class="link"><span class="fa fa-facebook"></span></a>
                              <a href="#" class="zoom"><span class="fa fa-twitter"></span></a>
                          </div>
                      </div>
                      <div class="team-details">
                          <h4> Linda Glendell </h4>
                          <h6> Teaching Professor </h6>
                          <p> Phasellus lorem augue, vulputate vel orci id, ultricies aliquet risus. </p>
                      </div>
                  </div>
              </div>
              <div class="column dt-sc-one-fourth">
                  <div class="dt-sc-team">
                      <div class="image">
                          <img class="item-mask" src="https://wedesignthemes.com/html/kidslife/images/mask.png"
                              />
                          <img src="https://wedesignthemes.com/html/kidslife/images/team3.jpg" />
                          <div class="dt-sc-image-overlay">
                              <a href="#" class="link"><span class="fa fa-facebook"></span></a>
                              <a href="#" class="zoom"><span class="fa fa-twitter"></span></a>
                          </div>
                      </div>
                      <div class="team-details">
                          <h4> Kate Dennings </h4>
                          <h6> Children Diet </h6>
                          <p> Phasellus lorem augue, vulputate vel orci id, ultricies aliquet risus. </p>
                      </div>
                  </div>
              </div>
              <div class="column dt-sc-one-fourth">
                      <div class="dt-sc-team">
                          <div class="image">
                              <img class="item-mask" src="https://wedesignthemes.com/html/kidslife/images/mask.png"
                                  />
                              <img src="https://wedesignthemes.com/html/kidslife/images/team4.jpg" />
                              <div class="dt-sc-image-overlay">
                                  <a href="#" class="link"><span class="fa fa-facebook"></span></a>
                                  <a href="#" class="zoom"><span class="fa fa-twitter"></span></a>
                              </div>
                          </div>
                          <div class="team-details">
                              <h4> Kristof Slinghot </h4>
                              <h6> Management </h6>
                              <p> Phasellus lorem augue, vulputate vel orci id, ultricies aliquet risus. </p>
                          </div>
                      </div>
                  </div>
              </div> */}
          

          <div class="dt-sc-hr"></div>

          {/* <section class="fullwidth-background dt-sc-parallax-section product_bg">

              <div class="container">
                  <h2 class="dt-sc-hr-white-title">Recent Products</h2>
                  <ul class="products">
                      <li class="dt-sc-one-fourth column first">
                          <div class="product-thumb">
                              <a href="#">
                                  <img src="https://wedesignthemes.com/html/kidslife/images/product1.jpg"/>
                              </a>
                              <span class="sale"> Sale! </span>
                              <div class="image-overlay">
                                  <div class="product-button">
                                      <a href="#" class="add-cart-btn"> Add to cart </a>
                                  </div>
                              </div>
                          </div>
                          <div class="product-details">
                              <h5><a href="#"> Ellents Style Grade </a></h5>
                              <span class="price"> $20.00 </span>
                          </div>
                      </li>
                      <li class="dt-sc-one-fourth column">
                          <div class="product-thumb">
                              <a href="#">
                                  <img src="https://wedesignthemes.com/html/kidslife/images/product2.jpg" />
                              </a>
                              <div class="image-overlay">
                                  <div class="product-button">
                                      <a href="#" class="add-cart-btn"> Add to cart </a>
                                  </div>
                              </div>
                          </div>
                          <div class="product-details">
                              <h5><a href="#"> Ellents Style Grade </a></h5>
                              <span class="price"> $20.00 </span>
                          </div>
                      </li>
                      <li class="dt-sc-one-fourth column">
                          <div class="product-thumb">
                              <a href="#">
                                  <img src="https://wedesignthemes.com/html/kidslife/images/product3.jpg" />
                              </a>
                              <span class="sale"> Sale! </span>
                              <div class="image-overlay">
                                  <div class="product-button">
                                      <a href="#" class="add-cart-btn"> Add to cart </a>
                                  </div>
                              </div>
                          </div>
                          <div class="product-details">
                              <h5><a href="#"> Ellents Style Grade </a></h5>
                              <span class="price"> $20.00 </span>
                          </div>
                      </li>
                      <li class="dt-sc-one-fourth column">
                          <div class="product-thumb">
                              <a href="#">
                                  <img src="https://wedesignthemes.com/html/kidslife/images/product4.jpg" />
                              </a>
                              <div class="image-overlay">
                                  <div class="product-button">
                                      <a href="#" class="add-cart-btn"> Add to cart </a>
                                  </div>
                              </div>
                          </div>
                          <div class="product-details">
                              <h5><a href="#"> Ellents Style Grade </a></h5>
                              <span class="price"> $20.00 </span>
                          </div>
                      </li>
                  </ul>
              </div>

          </section> */}

        </section>
      </div>


    </main>
  );
};

export default Home;
